/**
 * Created by Felix on 01-Nov-22.
 */

import 'theme/blue-angels'
import './entry.scss'

import render from './entry.html';
import 'animate.css';

import Vue from 'vue';
import VueRouter from 'vue-router';
import VueClipboard from 'vue-clipboard2'
import Buefy from 'buefy'
import store from 'module/store';

import {LOADING, ERROR} from "module/constants";

import getRoutes from 'module/routes';
import filters from 'module/filters';
import Cookies from 'js-cookie';
import CookieBanner from '../../resource/component/cookies-banner/component.vue';
import MarketingPreferencesModal from'../../resource/component/marketing-preference/component.vue';

import Error from 'component/error';
import SignIn from 'component/sign-in';
import DropdownMenu from 'component/core/dropdown-menu';
import NavigationBar from 'component/navigation-bar';
import SideNavAlternative from 'component/filter-container';
import Overlay from 'component/overlay';

const LOGIN_METHOD_GOOGLE = 'google';
const LOGIN_METHOD_EMAIL_TOKEN = 'emailToken';
const LOGIN_METHOD_ALL = 'all';

Vue
    .use(VueClipboard)
    .use(Buefy, {
      defaultIconPack: 'fa',
      defaultIconComponent: 'fa',
      customIconPacks: {
        fas: {
          sizes: {
            'default': 'fa-xs',
            'is-small': 'xs',
            'is-medium': 'lg',
            'is-large': 'xl'
          },
          iconPrefix: ''
        }
      }
    })
    .use(VueRouter);

let routesContext = require.context('./routes/', true, /page\.(js|vue)$/);

let routes = getRoutes(routesContext);

routes.unshift({
  path: '/',
  redirect: '/overview'
});

routes.unshift({
  path: '*',
  redirect: '/overview'
});

let router = new VueRouter({
  routes
});

const jobsModule = await import('module/specialistStore/primaryCostEstimate');
store.registerModule('pce', jobsModule.default);

//create a container for the app
let container = document.createElement('div');
document.body.appendChild(container);

let App = render({
  el: container,
  store,
  router,
  filters,
  components: {
    CookieBanner,
    MarketingPreferencesModal,
    Error,
    SignIn,
    DropdownMenu,
    NavigationBar,
    SideNavAlternative,
    Overlay
  },
  beforeCreate() {
    const onlyEmailLogin = Cookies.get('U_TYPE') !== 'internal';
    this.$store.dispatch('user/initLoginMethods', onlyEmailLogin ? LOGIN_METHOD_EMAIL_TOKEN : null);
  },
  data() {
    return {
      isActive: false,
      showDropdown: false,
      isModalActive: false,
      showMarketingPreferences: true,
      forceShowMarketingPreferences: false,
      profileIconColor: '#d6ccbc',
      notificationClosedByUser: false,
      notificationBannerActive: false,
      isSaving: false,
      overlayStyles: {
        'color': 'black',
      },
      reasonsForCall: [
        'Request call from estimator',
        'I need an amendment',
        'I can not find my reports',
        'I want to make payment',
        'I just want to speak to someone',
      ],
    }
  },
  computed: {
    emailOnly() {
      return Cookies.get('U_TYPE') !== 'internal';
    },
    companyName() {
      return this.$store.getters['company/selectedCompany']?.name;
    },
    isExternalCompany() {
      return this.$store.getters['user/isExternalCompany'];
    },
    marketingAcknowledged() {
      const user = this.$store.getters['user/loggedInUser'];
      return user && user.preferences && user.preferences.marketing && user.preferences.marketing.acknowledged;
    },
    userType() {
      return this.$store.getters['user/type'];
    },
    companyId() {
      return this.isExternalCompany ? this.$store.getters['user/limitationValues']('EXTERNAL_COMPANY')[0] : null;
    },
    loginState() {
      return this.$store.state.user.loggedInUser.state.state;
    },
    quoteLoadingState() {
      return this.$store.state.quote.selected.state;
    },
    quoteUploading() {
      return this.$store.state.company.saving[this.companyId + '_addQuote'] || null;
    },
    companyLoadingState() {
      return this.$store.state.company.selected.state;
    },
    deviceIsMobile() {
      return this.$store.state.device.type === 'mobile';
    },
    isDev() {
      return this.$store.getters['user/isDev'];
    },
    projectBeingRepriced() {
      return _.get(this.quote, 'temp.projectBeingRepriced', false);
    },
    isLoading() {
      return this.quoteLoadingState === LOADING || this.companyLoadingState === LOADING;
    },
    company() {
      return this.$store.state.company.selected.company;
    },
    isPostcodeValid() {
      return _.get(this.quote, 'form.quoteInfo.customer.address.validPostcode');
    },
    overlay() {
      if (this.isLoading) {
        if (this.quoteLoadingState === LOADING) {
          return {
            type: 'is-primary',
            title: 'Loading your project',
            subTitle: 'Please wait while we load your project. This page will refresh automatically',
            showProgress: true
          }
        } else {
          return {
            type: 'is-primary',
            title: 'Loading your company',
            subTitle: 'Please wait while we load your company. This page will refresh automatically',
            showProgress: true
          }
        }
      } else if (this.quoteUploading) {
        return {
          type: 'is-primary',
          title: 'Creating your Project',
          subTitle: 'Please wait while we create your project. This page will refresh automatically',
          showProgress: true
        }
      } else {
        return null;
      }
    },
    isDownloading() {
      return this.$store.getters['generic/isDownloading'];
    },
    iconForCallbackButton() {
      switch (this.isSaving) {
        case true:
          return 'spinner';
        case false:
          return 'phone';
      }
    },
    requestCallbackButtonText() {
      switch (this.isSaving) {
        case true:
          return 'Requesting';
        case false:
          return 'Call Me';
      }
    },
    isExternalUser() {
      return this.$store.getters['user/isExternalCompany'];
    },
  },
  watch: {
    loginState: {
      immediate: true,
      handler: 'loginStateChange'
    },
  },
  mounted() {
    document.body.classList.add('co-pilot');
    this.notificationClosedByUser = Cookies.get('notification-acknowledged') === '1';

    this.$store.dispatch('view/defaultWindow', {
      // minimised: false,
      leftControls: ['minimise']
    });
    window.addEventListener('beforeunload', this.beforeWindowUnload);
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.beforeWindowUnload);
  },
  methods: {
    loginStateChange() {
      if (this.loginState === 'SIGNED_IN' && this.companyId !== null) {
        this.$store.dispatch('company/select', {_id: this.companyId});
      }
    },
    filterProjects(filterParam) {
      this.$store.dispatch('company/clearFilteredProjects');
    },
    beforeWindowUnload() {
      // Cookies.remove('U_TYPE');
    },
    resetCompany() {
      this.$store.commit('company/selectedCompany', null);
      this.$router.push({name: 'overview'});
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    requestCallback(reason) {
      this.showDropdown = false;
      this.isModalActive = true;
      this.$store.dispatch('company/requestCallback', {
        company: this.$store.getters['company/selectedCompany'],
        reason: reason,
      });
    },
    openMarketingPreferences() {
      this.forceShowMarketingPreferences = true;
    },
    closeMarketingPreferences() {
      this.forceShowMarketingPreferences = false;
      this.showMarketingPreferences = false;
    },
  }
});

new Vue(App);